<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/training',
          title: 'Training'
        },
        {
          href: '/training/workshops',
          title: 'Workshops'
        }
      ]"
      :value="onDemandPage.hero_section"
    >
      <template v-if="onDemandPage.hero_section.cta" #cta>
        <HeroCta :value="onDemandPage.hero_section.cta" />
      </template>
    </HeroSection>

    <TrainingDifferentiatorsSection
      :scroll-to-section="scrollToSection"
      :value="onDemandPage.training_differentiators_section"
      class="mb-16 hero-section hero-below-offset"
    />

    <LogoBarSection
      :items="logos"
      :value="onDemandPage.logo_bar_section"
      class="mb-16"
    />

    <ProductsOverviewSection
      :items="products"
      :learn-href="item => `/training/on-demand/${slugify(item)}`"
      :schedule-href="
        item =>
          `/training/schedule?deliveryMethod=D&what=${item.code.toLowerCase()}`
      "
      :value="onDemandPage.products_overview_section"
    />

    <CrossSellSection
      :value="onDemandPage.cross_sell_section"
      boxed
      outlined
      class="mb-8"
    />

    <v-container
      :ref="
        el => {
          sectionRefs.register = el
        }
      "
    />

    <v-lazy>
      <OccasionsSection
        :banner="banner"
        :filters-value="{ deliveryMethod: 'D' }"
        :value="onDemandPage.classes_section"
        :what-menu="whatMenu"
        class="mb-16"
      />
    </v-lazy>

    <ReviewsSection :items="reviews" class="mb-16" />

    <ServicesSection :value="onDemandPage.services_section" class="mb-16" />

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="onDemandPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { useProvideDeliveryMethodsStore } from '#root/lib/useDeliveryMethodsStore'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'
import { scrollToRefKey, slugify } from '#root/lib/utils'

const sectionRefs = reactive({})

const props = defineProps({
  banner: {
    default: undefined,
    type: Object
  },
  deliveryMethods: {
    required: true,
    type: Array
  },
  logos: {
    required: true,
    type: Array
  },
  reviews: {
    required: true,
    type: Array
  },
  trainers: {
    required: true,
    type: Array
  },
  whatMenu: {
    required: true,
    type: Object
  },
  products: {
    required: true,
    type: Array
  },
  onDemandPage: {
    required: true,
    type: Object
  }
})

useProvideDeliveryMethodsStore(props.deliveryMethods)
useProvideTrainerPersonsStore(props.trainers)

function scrollToSection({ key }) {
  scrollToRefKey(sectionRefs, key)
}
</script>
